import React, {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Outlet} from "react-router-dom";
import {Breadcrumb, Button, Card, Collapse, Space, Table, Tabs, Typography} from "antd";
import CollapsePanel from "antd/es/collapse/CollapsePanel";

import DB_Log from "../../../database/development/log";
import ModalWindow from "../../modal";
import {Context} from "../../../App";
import DB_Branch from "../../../database/dictionary/branch";
import DB_DocType from "../../../database/dictionary/doc-type";
import axios from "axios";
import DB_TradePointsType from "../../../database/dictionary/trade-point-type";
import DB_Chain from "../../../database/dictionary/chain";
import {ApiSales} from "./v1/sales/api_sales";
import {ApiRemains} from "./v1/remains/api_remains";
import {ApiTradePoints} from "./v1/trade_points/api_trade_points";
import {ApiOrdersPatch} from "./v1/orders/patch/api_orders_patch";
import {ApiOrdersGet} from "./v1/orders/get/api_orders_get";
import {ApiReturnsGet} from "./v1/returns/get/api_returns_get";
import {ApiPaymentsGet} from "./v1/payments/get/api_payments_get";
import {ApiReturnsPatch} from "./v1/returns/patch/api_returns_patch";
import {ApiPaymentsPatch} from "./v1/payments/patch/api_payments_patch";
import {ApiPriceListPost} from "./v1/price_lists/post/api_price_list_post";
import {ApiPayFormPost} from "./v1/pay_forms/post/api_pay_form_post";
import {ApiDebtsPost} from "./v1/debts/post/api_debts_post";
import {ApiRoutePost} from "./v1/routes/post/api_route_post";
import {ApiRemainPost} from "./v1/availability/post/api_remain_post";
import DB_OperationTypes from "../../../database/dictionary/operation_types";


const Documentation = () => {
    const {t} = useTranslation();
    const {token, locale, setToken} = useContext(Context);
    const {getDefaultValue} = DB_Log(token);
    const {getAPItoken} = DB_Branch(token)
    const {getDocTypes} = DB_DocType(token)
    const {getActiveTradePointsTypes} = DB_TradePointsType(token)
    const {getActiveChains} = DB_Chain(token)
    const {get} = DB_OperationTypes(token)
    const {errorConnect} = ModalWindow();
    const [wait, setWait] = useState(true)

    const [defaultValue, setDefaultValue] = useState([])
    const [docType, setDocType] = useState([])
    const [typeTradePoints, setTypeTradePoints] = useState([])
    const [chains, setChains] = useState([])
    const [operationTypes, setOperationTypes] = useState([])



    const generateAPIkey = async (branch_id) => {
        const formData = new FormData
        formData.append('id', branch_id)

        getAPItoken(formData)
            .then(res => {
                if (res.status === 200) {
                    const n = defaultValue.map(df => {
                        if (df.branch_id === branch_id) {
                            return {...df, api_token: res.data.token.toUpperCase()}
                        } else {
                            return {...df}
                        }
                    })

                    setDefaultValue(n)
                } else {
                    errorConnect()
                }
            })
            .catch(e => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    setWait(false)
                    errorConnect()
                }
            })

    }


    useEffect(() => {
        window.scroll(0, 0)

        axios.all([
            getDefaultValue(),
            getDocTypes(),
            getActiveTradePointsTypes(),
            getActiveChains(),
            get(new AbortController(), {active: true})
        ])
            .then(axios.spread((defaultValues, doc_types, type_tp, chains, operationTypes) => {
                setDefaultValue(defaultValues.data)
                setDocType(doc_types.data.data)
                setTypeTradePoints(type_tp.data)
                setChains(chains.data)
                setOperationTypes(operationTypes.data.data)
                setWait(false)
            }))
            .catch(e => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    setWait(false)
                    errorConnect()
                }
            })
    }, [])


    return (
        <div>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb
                        style={{
                            margin: '15pt 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>{t('documentation')}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                </Space>


                <Card>
                    <Tabs>
                        <Tabs.TabPane tab={t('authorization')} key="1">
                            <Typography.Text>
                                {t('authorization_text1')}
                                <br/><br/>
                                {t('authorization_text2')}
                                <br/><br/>
                                {t('authorization_text3')}
                                <br/><br/>
                                {t('authorization_text4')}
                            </Typography.Text>
                            <br/><br/><br/>
                            <Typography.Text strong style={{fontWeight: 'bold'}}>{t('parameters')}</Typography.Text>
                            <br/>
                            <br/>
                            <Table size={'small'} pagination={false} dataSource={
                                [
                                    {
                                        key: '1',
                                        parameter: 'Authorization',
                                        value: t('api_token'),
                                    }
                                ]
                            }
                                   columns={
                                       [
                                           {
                                               title: t('parameters'),
                                               dataIndex: 'parameter',
                                               key: 'parameter'
                                           },
                                           {
                                               title: t('value'),
                                               dataIndex: 'value',
                                               key: 'value'
                                           },
                                       ]
                                   }
                            />

                        </Tabs.TabPane>

                        <Tabs.TabPane tab={t('default_value')} key="2">
                            {t('default_value_text')}
                            <br/>
                            <br/>

                            <Table
                                size={'small'}
                                pagination={false}
                                loading={wait}
                                dataSource={defaultValue}
                                rowKey="id"
                                columns={
                                    [
                                        {
                                            title: t('distributor'),
                                            dataIndex: 'distributor',
                                        },
                                        {
                                            title: t('branch'),
                                            dataIndex: 'branch',
                                        },
                                        {
                                            title: t('geography'),
                                            dataIndex: 'geography',
                                        },
                                        {
                                            title: t('api_token'),
                                            dataIndex: 'api_token',
                                            render: (token) => { if (token != null) return token.toUpperCase() }
                                        },
                                        {
                                            title: t('actions'),
                                            dataIndex: 'actions',
                                            render: (_, record) => {
                                                return (
                                                    <>
                                                        <Button onClick={_ => generateAPIkey(record.branch_id)}
                                                                type={'link'}>{t('generate_api_token')}</Button>
                                                    </>
                                                )
                                            }
                                        },

                                    ]
                                }
                            />

                            <br/>
                            <br/>
                            <Typography.Text>{t('doc_type') + ':'}</Typography.Text>
                            <Table pagination={false} size={'small'} loading={wait} rowKey={'id'} columns={[
                                {
                                    title: 'ID',
                                    dataIndex: 'id',
                                },
                                {
                                    title: t('name'),
                                    dataIndex: 'name',
                                },
                            ]}
                                   dataSource={docType}
                            />

                            <br/>
                            <br/>
                            <Typography.Text>{t('trade_points_types') + ':'}</Typography.Text>
                            <Table pagination={false} size={'small'} loading={wait} rowKey={'id'} columns={[
                                {
                                    title: 'ID',
                                    dataIndex: 'id',
                                },
                                {
                                    title: t('name'),
                                    dataIndex: 'name',
                                },
                            ]}
                                   dataSource={typeTradePoints}
                            />

                            <br/>
                            <br/>
                            <Typography.Text>{t('chains') + ':'}</Typography.Text>
                            <Table
                                pagination={false}
                                size={'small'}
                                loading={wait}
                                rowKey={'id'}
                                columns={[
                                    {
                                        title: 'ID',
                                        dataIndex: 'id',
                                    },
                                    {
                                        title: t('name'),
                                        dataIndex: 'name',
                                    },
                                ]}
                                dataSource={chains}
                            />

                            <br/>
                            <br/>
                            <Typography.Text>{t('operation_types') + ':'}</Typography.Text>
                            <Table
                                pagination={false}
                                size={'small'}
                                loading={wait}
                                rowKey={'id'}
                                dataSource={operationTypes}
                                columns={[
                                    {
                                        title: 'ID',
                                        dataIndex: 'id',
                                    },
                                    {
                                        title: t('name'),
                                        dataIndex: 'name',
                                    },
                                ]}
                            />
                        </Tabs.TabPane>

                        <Tabs.TabPane tab={t('API')} key="3">
                            <Typography.Title level={4}>{t('start_host')}</Typography.Title>
                            {t('api_text1')}
                            <br/><br/>
                            {t('api_text2')}
                            <br/>
                            {t('api_text3')}
                            <br/><br/>
                            {t('api_text4')}
                            <br/><br/>
                            {t('api_text5')}
                            <br/><br/>
                            <Typography.Title level={4}>{t('how_its_work')}</Typography.Title>
                            {t('descriptions_about_work_api_response_1')}
                            <br/>
                            {t('descriptions_about_work_api_response_2')}
                            <br/><br/>
                            {t('descriptions_about_work_api_response_3')}
                            <br/><br/>

                            <Typography.Title level={4}>{t('what_next')}</Typography.Title>
                            {t('descriptions_about_work_api_response_4')}
                            <br/>
                            {t('logs_saved_days')}
                            <br/><br/>

                            <Collapse defaultActiveKey={[]} ghost>
                                <CollapsePanel key={1} header={
                                    <Typography.Title level={4}>{t('sales')}</Typography.Title>
                                }
                                >
                                    <ApiSales/>
                                </CollapsePanel>

                                <CollapsePanel key={2} header={
                                    <Typography.Title level={4}>{t('remains')}</Typography.Title>
                                }>
                                    <ApiRemains/>
                                </CollapsePanel>

                                <CollapsePanel key={3} header={
                                    <Typography.Title level={4}>{t('trade_points')}</Typography.Title>
                                }>
                                    <ApiTradePoints />
                                </CollapsePanel>

                                <CollapsePanel key={4} style={{paddingBottom:'0'}} header={
                                    <Typography.Title level={4} style={{marginBottom:'0'}}>{t('orders')}</Typography.Title>
                                }>
                                    <ApiOrdersGet />
                                    <ApiOrdersPatch />
                                </CollapsePanel>

                                <CollapsePanel key={5} style={{paddingBottom:'0'}} header={
                                    <Typography.Title level={4} style={{marginBottom:'0'}}>{t('returns')}</Typography.Title>
                                }>
                                    <ApiReturnsGet />
                                    <ApiReturnsPatch />
                                </CollapsePanel>

                                <CollapsePanel key={6} style={{paddingBottom:'0'}} header={
                                    <Typography.Title level={4} style={{marginBottom:'0'}}>{t('payments')}</Typography.Title>
                                }>
                                    <ApiPaymentsGet />
                                    <ApiPaymentsPatch />
                                </CollapsePanel>

                                <CollapsePanel key={7} style={{paddingBottom:'0'}} header={
                                    <Typography.Title level={4} style={{marginBottom:'0'}}>{t('price_lists')}</Typography.Title>
                                }>
                                    <ApiPriceListPost />
                                </CollapsePanel>

                                <CollapsePanel key={8} style={{paddingBottom:'0'}} header={
                                    <Typography.Title level={4} style={{marginBottom:'0'}}>{t('pay_forms')}</Typography.Title>
                                }>
                                    <ApiPayFormPost />
                                </CollapsePanel>

                                <CollapsePanel key={9} style={{paddingBottom:'0'}} header={
                                    <Typography.Title level={4} style={{marginBottom:'0'}}>{t('debts')}</Typography.Title>
                                }>
                                    <ApiDebtsPost />
                                </CollapsePanel>

                                <CollapsePanel key={10} style={{paddingBottom:'0'}} header={
                                    <Typography.Title level={4} style={{marginBottom:'0'}}>{t('routes')}</Typography.Title>
                                }>
                                    <ApiRoutePost />
                                </CollapsePanel>

                                <CollapsePanel key={11} style={{paddingBottom:'0'}} header={
                                    <Typography.Title level={4} style={{marginBottom:'0'}}>{t('availability')}</Typography.Title>
                                }>
                                    <ApiRemainPost />
                                </CollapsePanel>

                            </Collapse>
                        </Tabs.TabPane>
                    </Tabs>
                </Card>

            </div>
            <Outlet/>
        </div>
    )
}

export default Documentation;
